import { RootState } from 'store/rootTypes';

export const OrderBoxSelector = (state: RootState) => state.OrderBox;
